import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { RADAR_INDICATOR, RADAR_DATA } from '../data/mockData';

// 区块4：交互式五维雷达图（本次试讲 / 班级平均 / 同主题优秀）
export default function ChartRadarEval() {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '五维教学能力雷达评价',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: ['本次试讲', '班级平均', '同主题优秀'],
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    radar: {
      indicator: RADAR_INDICATOR.map((item) => ({
        name: item.name,
        max: item.max,
        nameTextStyle: { color: '#e2e8f0', fontSize: 15, fontWeight: 'bold' },
      })),
      shape: 'polygon',
      splitNumber: 5,
      axisName: { color: '#e2e8f0' },
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.12)' } },
      splitArea: {
        show: true,
        areaStyle: {
          color: ['rgba(6,182,212,0.05)', 'rgba(6,182,212,0.1)', 'rgba(6,182,212,0.05)', 'rgba(6,182,212,0.1)', 'rgba(6,182,212,0.05)'],
        },
      },
      axisLine: { lineStyle: { color: 'rgba(255,255,255,0.15)' } },
    },
    series: [
      {
        name: '教学能力评价',
        type: 'radar',
        data: [
          {
            value: RADAR_DATA.current,
            name: '本次试讲',
            itemStyle: { color: '#06b6d4' },
            areaStyle: { color: 'rgba(6, 182, 212, 0.3)' },
            lineStyle: { width: 3 },
          },
          {
            value: RADAR_DATA.average,
            name: '班级平均',
            itemStyle: { color: '#fbbf24' },
            areaStyle: { color: 'rgba(251, 191, 36, 0.2)' },
            lineStyle: { width: 2, type: 'dashed' },
          },
          {
            value: RADAR_DATA.excellent,
            name: '同主题优秀',
            itemStyle: { color: '#22c55e' },
            areaStyle: { color: 'rgba(34, 197, 94, 0.15)' },
            lineStyle: { width: 2, type: 'dotted' },
          },
        ],
        animationDuration: 1500,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 480 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
